<template>
  <div class="wrapper">
    <loading :isShow="uploadLoading" />
    <div class="demo-upload-list" v-for="(item, index) in imgList" :key="index" :class="{ 'demo-upload-list-img': autoImgSize }">
      <template v-if="fileType == 'img'">
        <img :src="item.path" style="width: 120px" :preview="_uid" :ref="'img' + index" />
        <div class="demo-upload-list-cover" :class="{ 'ont-btn': !(isDel && !disabled) }">
          <Icon
            type="ios-eye-outline"
            @click.native="handleView(item, index)"
            v-if="checkType(item.path) == 'png' || checkType(item.path) == 'jpg' || checkType(item.path) == 'jpeg'"
          ></Icon>
          <Icon type="ios-trash-outline" @click.native="handleRemove(index)" v-if="isDel && !disabled"></Icon>
        </div>
      </template>
      <template v-else-if="fileType === 'video'">
        <video :src="item" style="width: 120px" />
        <div class="demo-upload-list-cover ont-btn">
          <Icon type="ios-trash-outline" @click.native="handleRemove(index)" v-if="isDel && !disabled"></Icon>
        </div>
      </template>
      <template v-else>
        <div v-if="checkType(item.path) == 'pdf'">
          <img src="@/static/images/cc_pdf_new.png" class="avatar" />
          <span v-if="showFileName" class="file-name">{{ item.fileName }}</span>
        </div>
        <img v-else-if="checkType(item.path) == 'xls' || checkType(item.path) == 'xlsx'" src="@/static/images/cc_excel.png" class="avatar" />
        <img v-else-if="checkType(item.path) == 'docx' || checkType(item.path) == 'doc'" src="@/static/images/cc_word.png" class="avatar" />
        <img v-else-if="checkType(item.path) == 'ppt' || checkType(item.path) == 'pptx'" src="@/static/images/cc_ppt.png" class="avatar" />
        <img :src="item.path" style="width: 120px" v-else :preview="_uid" :ref="'img' + index" />
        <div class="demo-upload-list-cover" :class="{ 'ont-btn': !(isDel && !disabled) }">
          <Icon
            type="ios-eye-outline"
            @click.native="handleView(item, index)"
            v-if="checkType(item.path) == 'png' || checkType(item.path) == 'jpg' || checkType(item.path) == 'jpeg' || checkType(item.path) == 'pdf'"
          ></Icon>
          <Icon type="ios-download-outline" v-else @click.native="handleView(item, index)" />
          <Icon type="ios-trash-outline" @click.native="handleRemove(index)" v-if="isDel && !disabled"></Icon>
        </div>
      </template>
    </div>

    <a href="javascript:;" class="a-upload" v-if="showUpload">
      <input type="file" ref="uploadFileVal" @change="handelUploadFile" :accept="accept" class="input-file" :multiple="multiple" title="" />
      <Icon type="ios-add" size="52" class="icon-add"></Icon>
    </a>
  </div>
</template>

<script>
import { uploadFile } from '@/api/httpList';
import _ from 'lodash';

export default {
  props: {
    // 是否可上传
    showUpload: {
      type: Boolean,
      default: true
    },
    // 限制可选文件类型后缀,多个用,隔开，例如'.pdf,.ppt,.png'
    accept: {
      type: String,
      default: '*'
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: false
    },
    // 文件上传效验类型
    fileType: {
      type: String,
      default: 'img'
    },
    limit: {
      type: Number,
      default: null
    },
    maxFileSize: {
      type: Number,
      default: null
    },
    muti: Boolean,
    txt: String,
    tip: String,
    modalWidth: String,
    isDel: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showFileName: {
      type: Boolean,
      default: false
    },
    autoImgSize: null, //上传图片自适应铺满
    value: ''
  },

  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          if (newVal instanceof Array) {
            this.imgList = newVal.map(item => {
              if (item.url) {
                return item.url;
              } else {
                return item;
              }
            });
          } else {
            this.imgList = [newVal];
          }
        } else {
          this.imgList = '';
        }
      },
      immediate: true //刷新加载 立马触发一次handler
      // deep: true  // 可以深度检测到 person 对象的属性值的变化
    }
  },

  data() {
    return {
      imgList: [],
      uploadLoading: false
    };
  },

  methods: {
    clear() {
      this.imgList = [];
      this.uploadLoading = false;
    },

    msg: _.throttle(
      function (txt) {
        if (this.fileType == 'pdf' && this.maxFileSize) {
          this.$Message.error(`请上传${Math.ceil(this.maxFileSize / 1024)}M以内的pdf文件`);
        } else {
          this.$Message.error(`上传格式不正确，请上传${txt}格式文件`);
        }
      },
      2000,
      { trailing: false }
    ),

    // 选择文件
    handelUploadFile(e) {
      if (this.limit && (this.imgList.length + e.target.files.length > this.limit || e.target.files.length > this.limit)) {
        this.$Message.error(`上传文件个数超过${this.limit}个`);
        return;
      }

      var formData = new FormData();
      Object.keys(e.target.files).forEach(key => {
        this.uploadLoading = true;
        const file = e.target.files[key];
        //  上传文件只能是 PDF/EXCEL/WORD/PPT/JPG/PNG 格式!
        if (this.fileType == 'img') {
          const reg = /\.(png|jpg|jpeg)$/;
          const txt = '图片';
          if (!reg.test(file.name.toLowerCase())) {
            this.msg(txt);
            return false;
          }
        } else if (this.fileType == 'video') {
          const reg = /\.(mp4)$/;
          const txt = '视频';
          if (!reg.test(file.name.toLowerCase())) {
            this.msg(txt);
            return false;
          }
        } else if (this.fileType == 'many') {
          const reg = /\.(png|jpg|jpeg|pdf|xlsx|xls|doc|docx|ppt|pptx|)$/;
          const txt = 'PDF/EXCEL/WORD/PPT/JPG/PNG';
          if (!reg.test(file.name.toLowerCase())) {
            this.msg(txt);
            return false;
          }
        } else {
          const reg = eval('/\.(' + this.fileType + ')$/');
          const txt = this.fileType.replace(/\|/g, ',');
          if (!reg.test(file.name.toLowerCase())) {
            this.msg(txt);
            return false;
          }
        }
        if (this.maxFileSize && file.size / 1024 > this.maxFileSize) {
          this.msg();
          return;
        }
        this.$emit('before-upload', this.imgList, file);
        formData.append('file', file);
      });

      uploadFile(formData).then(res => {
        res.data.map(item => {
          this.imgList.push(item);
          this.$emit('change', this.imgList);
        });
        this.uploadLoading = false;
      });
      setTimeout(() => {
        this.$refs.uploadFileVal.value = '';
      }, 2000);
    },

    // 获取文件类型
    checkType(path) {
      return path && path.split('.').pop().toLowerCase();
    },

    // 预览
    handleView(item, index) {
      if (['png', 'jpg', 'jpeg'].includes(this.checkType(item.path))) {
        this.$refs['img' + index][0].click();
      } else if (this.checkType(item.path) == 'pdf') {
        window.open(item.path, '_blank');
      } else {
        location.href = item.path;
      }
    },

    // 移除
    handleRemove(index) {
      this.imgList.splice(index, 1);
      this.$emit('change', this.imgList);
    }
  }
};
</script>

<style lang="scss" scoped>
input {
  width: 120px;
  height: 120px;
  border: 1px dashed #dcdee2;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 1s all;
}

input:hover {
  border: 1px dashed #3399ff;
}

input[type='file'] {
  color: transparent;
}

input #file-upload-button {
  color: red;
}

input.input-file::file-selector-button {
  display: none;
}

.a-upload {
  position: relative;
  height: 120px;

  .icon-add {
    color: #3399ff;
    position: absolute;
    top: 50%;
    margin-top: -26px;
    left: 50%;
    margin-left: -26px;
    z-index: -1;
  }
}

.wrapper {
  display: flex;
  flex-wrap: wrap;
  .demo-upload-list {
    display: inline-block;
    width: 120px;
    height: 120px;
    text-align: center;
    line-height: 120px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    margin-right: 4px;
    margin-bottom: 4px;
  }

  .demo-upload-list:hover .file-name {
    display: none;
  }

  .demo-upload-list img {
    width: 100%;
    height: 100%;
  }

  .demo-upload-list-img {
    width: 100%;
    max-width: 280px;
    height: 173px;
    background-color: #f5f7f9;
    box-shadow: none;
    img {
      width: auto !important;
      max-width: 100%;
      object-fit: cover;
    }
  }

  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);

    align-items: center;
    justify-content: center;
  }

  .file-name {
    position: absolute;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    line-height: 15px;
    width: 100%;
    padding: 2px 5px;
    text-align: left;
    color: #fff;
    font-size: 12px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis; /* 超出部分省略号 */
    display: -webkit-box; /* 对象作为伸缩盒子模型显示 */
    -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
    -webkit-line-clamp: 2; /* 显示的行数 */
    max-height: 30px; /* 设置最大高度，根据行高，要几行乘以几倍 */
  }

  .demo-upload-list:hover .demo-upload-list-cover {
    display: flex;
  }

  .demo-upload-list-cover {
    &.ont-btn {
      width: 100%;
      height: 100%;
      align-items: center;
      i {
        width: 100%;
        height: 100%;
        align-items: center;
        display: flex;
        justify-content: center;
      }
    }
    i {
      color: #fff;
      font-size: 20px;
      cursor: pointer;
      padding: 10px;
    }
  }

  .imgList {
    float: left;

    li {
      position: relative;
      float: left;
      width: 120px;
      height: 120px;
      margin: 10px;

      .close {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        text-align: center;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          margin-right: 10px;
        }

        &:hover {
          cursor: pointer;

          &:last-child {
            margin-right: 0;
          }
        }
      }

      img {
        &:hover {
          cursor: pointer;
        }

        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
